import { render, staticRenderFns } from "./ReportDesktopCreditUser.vue?vue&type=template&id=08c566f4"
import script from "./ReportDesktopCreditUser.vue?vue&type=script&lang=js"
export * from "./ReportDesktopCreditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports